export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-3-480-e552377d9897e95d90cbf415f32796d1.webp";